import { atom, DefaultValue, selector } from "recoil";

export const raSearchState = atom({
    key: 'raSearch',
    default: {
        filterParams: null,
        raList: []
    }
});

export const raFilterParams = selector<any>({
    key: 'raFilterParams',
    get: ({ get }) => get(raSearchState).filterParams,
    set: ({ set, get }, newValue) => {
        set(raSearchState, {
            ...get(raSearchState),
            filterParams: newValue instanceof DefaultValue ? get(raSearchState).filterParams : newValue
        })
    }
});

export const raSearchListState = selector<any>({
    key: 'raSearchList',
    get: ({ get }) => get(raSearchState).raList,
    set: ({ set, get }, newValue) => {
        set(raSearchState, {
            ...get(raSearchState),
            raList: newValue instanceof DefaultValue ? get(raSearchState).raList : newValue
        })
    }
});
